import Container from "../core/Container"
import Heading from "../core/Heading"
import Image from "../core/Image"
import Paragraph from "../core/Paragraph"
import Button from "../core/Button"
import { useNavigate } from "react-router-dom"


export default function Entity({entity, lecturer}) {

    const navigate = useNavigate();

    const lecturerName = `${lecturer.before_name} ${lecturer.name} ${lecturer.surname} ${lecturer.after_name}`

    const handleZjistitViceClick = (id) => {
        navigate(`/nabidka?id=${id}`)
    }

    return(
        <Container className="w-full grid grid-cols-1 sm:grid-cols-[30%_auto_70%] md:grid-cols-[25%_auto_60%_15%] lg:grid-cols-[12%_auto_58%_30%] gap-3 items-center mb-4 border border-gray-200 p-3 rounded-md shadow-md">
            {/* Obrázek - na mobilu plná šířka nahoře, na sm+ vedle textu */}
            <Container bgColor="transparent" className="flex items-center justify-center">
                <Image src={`courses_icons/${entity.thumbnail}`} alt={`${entity.name} thumbnail`} width={150}/>
            </Container>
            <Container bgColor="main" className="hidden sm:block w-1 h-full min-h-[100px] rounded-lg self-stretch"></Container>
            <Container bgColor="transparent" className="min-w-0"> 
                <Heading variant="h3" className="mb-3">{entity.is_available ? (entity.name) : (`🔒${entity.name}`)}</Heading>
                {/* Informace s ikonami - v jedné řádce */}
                <Container bgColor="transparent" className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-2">
                    {/* Lektor */}
                    <Container bgColor="transparent" className="flex items-center gap-1.5">
                        <svg className="w-4 h-4 text-main flex-shrink-0 inline-block align-middle" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        <Paragraph variant="xs" className="inline-block align-middle">{lecturerName}</Paragraph>
                    </Container>
                    
                    {/* Formát */}
                    <Container bgColor="transparent" className="flex items-center gap-1.5">
                        <svg className="w-4 h-4 text-main flex-shrink-0 inline-block align-middle" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <Paragraph variant="xs" className="inline-block align-middle">{entity.format}</Paragraph>
                    </Container>
                    
                    {/* Místo konání */}
                    <Container bgColor="transparent" className="flex items-center gap-1.5">
                        <svg className="w-4 h-4 text-main flex-shrink-0 inline-block align-middle" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <Paragraph variant="xs" className="inline-block align-middle">{entity.location}</Paragraph>
                    </Container>
                    
                    {/* Datum realizace */}
                    <Container bgColor="transparent" className="flex items-center gap-1.5">
                        <svg className="w-4 h-4 text-main flex-shrink-0 inline-block align-middle" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <Paragraph variant="xs" className="inline-block align-middle">{entity.realization_date}</Paragraph>
                    </Container>
                </Container>
                
                {/* Cena - na samostatném řádku */}
                <Container bgColor="transparent" className="flex items-center gap-1.5 border-t border-gray-200 pt-2">
                    {entity.is_available && (
                        <span className="text-md font-bold text-main">
                            {Number(entity.live_price) > 0
                                ? `Cena: ${entity.live_price} Kč`
                                : "ZDARMA"}
                        </span>
                    )}
                    {!entity.is_available && <span className="text-md font-bold text-main">🔒KURZ JE JIŽ UZAVŘENÝ</span>}
                </Container>

            </Container>
            {/* Button - na mobilu a sm plná šířka dole (sm:col-span-3 = přes všechny sloupce), na md+ vlastní sloupec */}

            {entity.is_available && (<Container bgColor="transparent" className="col-span-1 flex items-center lg:justify-center md:justify-start sm:justify-start sm:col-span-3 md:col-span-4 lg:col-span-1">
                <Button size="md" variant="primary" onClick={() => handleZjistitViceClick(entity.id)}>Zjistit více</Button>  
            </Container>)}
        </Container>
    )
}